import { ServerEIPInfo, ServerNATInfo } from '@/api/type-server'

export enum EIPStatus {
  Unknown = 0,
  Available = 1,
  InUse = 2,
}

export const eipStatusMap = {
  [EIPStatus.Unknown]: {
    label: 'Unknown',
    style: 'status-grey',
  },
  [EIPStatus.Available]: {
    label: 'Available',
    style: 'status-green',
  },
  [EIPStatus.InUse]: {
    label: 'In Use',
    style: 'status-blue',
  },
}

export class EIP {
  resID: string
  wanIP: string
  status: number
  priceMillicent: number
  region: number

  constructor(props: ServerEIPInfo) {
    this.resID = props.resID
    this.wanIP = props.wanIP
    this.status = props.status
    this.priceMillicent = props.priceMillicent
    this.region = props.region
  }

  get pricePerHour(): number {
    return this.priceMillicent / 100000
  }

  get statusLabel(): string {
    return eipStatusMap[this.status as EIPStatus]?.label || 'Unknown'
  }

  get statusStyle(): string {
    return eipStatusMap[this.status as EIPStatus]?.style || 'status-grey'
  }
}

// EIP from purchased list (NAT with network_type=6)
export class PurchasedEIP {
  resID: string
  name: string
  createTime: { seconds: number }
  clusterType: number
  domain: number
  capacity: ServerNATInfo['capacity']
  amount: number
  bandwidth: ServerNATInfo['bandwidth']

  constructor(props: ServerNATInfo) {
    this.resID = props.resID
    this.name = props.name
    this.createTime = props.createTime
    this.clusterType = props.clusterType
    this.domain = props.domain
    this.capacity = props.capacity
    this.amount = props.amount
    this.bandwidth = props.bandwidth
  }
}
